import { render, staticRenderFns } from "./Autorizacion-fajillas.vue?vue&type=template&id=252013c0&scoped=true&"
import script from "./Autorizacion-fajillas.vue?vue&type=script&lang=js&"
export * from "./Autorizacion-fajillas.vue?vue&type=script&lang=js&"
import style0 from "./Autorizacion-fajillas.vue?vue&type=style&index=0&id=252013c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252013c0",
  null
  
)

export default component.exports